<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="-mb-16px">
        <el-form
          ref="searchRefs"
          :model="params"
          size="small"
          label-width="70px"
          inline
        >
          <el-form-item label="账号" prop="username">
            <el-input
              v-model="params.username"
              placeholder="请输入账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="params.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input
              v-model="params.email"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="params.status" placeholder="请选择状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="1"></el-option>
              <el-option label="停用" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="ml-6px">
            <el-button type="primary" @click="getList(1)">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="mt-16px" v-loading="pager.loading" shadow="never">
      <div>
        <el-button
          v-if="$hasPermission('system.customer', 'create')"
          type="primary"
          size="small"
          @click="onNew"
        >
          新增子账户
        </el-button>
      </div>
      <div class="mt-16px">
        <div class="data-table-scroll" style="--table-min-width: 1140px">
          <el-table :data="pager.list">
            <el-table-column
              prop="id"
              label="账号ID"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="username"
              label="登录账号"
              width="150"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="绑定站点" min-width="260">
              <template v-slot="scope">
                <template
                  v-if="scope.row.bindings && scope.row.bindings.length"
                >
                  <div
                    v-for="binding in scope.row.bindings"
                    :key="binding.site_id"
                    class="customer-site"
                  >
                    <div :title="binding.site_name">
                      {{ binding.site_name || "-" }}
                    </div>
                    <small class="muted" :title="binding.site_url">
                      {{ binding.site_url || "-" }}
                    </small>
                  </div>
                </template>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="页面权限" min-width="210">
              <template v-slot="scope">
                <el-tag
                  v-for="item in pagePermissionLabels(
                    scope.row.page_permissions
                  )"
                  :key="item"
                  size="small"
                  class="mr-6px"
                >
                  {{ item }}
                </el-tag>
                <span
                  v-if="
                    !pagePermissionLabels(scope.row.page_permissions).length
                  "
                >
                  -
                </span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" width="160">
              <template v-slot="scope">
                <span>
                  {{ formatDate(scope.row.create_time, "yyyy-mm-dd hh:MM:ss") }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="最近登录" width="160">
              <template v-slot="scope">
                <span v-if="scope.row.last_login_at">
                  {{
                    formatDate(scope.row.last_login_at, "yyyy-mm-dd hh:MM:ss")
                  }}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="80">
              <template v-slot="scope">
                <el-tag size="small" v-if="scope.row.status === 1">正常</el-tag>
                <el-tag size="small" type="danger" v-else>停用</el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="190">
              <template v-slot="scope">
                <div class="flex items-center">
                  <el-button
                    v-if="$hasPermission('system.customer', 'edit')"
                    type="text"
                    @click="onEdit(scope.row.id)"
                  >
                    编辑
                  </el-button>
                  <el-divider
                    v-if="
                      $hasPermission('system.customer', 'edit') &&
                      $hasPermission('system.customer', 'reset_password')
                    "
                    direction="vertical"
                  ></el-divider>
                  <el-button
                    v-if="$hasPermission('system.customer', 'reset_password')"
                    type="text"
                    @click="onResetPassword(scope.row)"
                  >
                    重置密码
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="flex justify-between mt-16px">
        <div class="flex"></div>
        <pagination
          v-model="pager"
          :pageSizes="[10, 20, 30]"
          @change="getList()"
        ></pagination>
      </div>
    </el-card>

    <password-dialog ref="passwordDialog"></password-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/pagination";
import { Pager } from "@/utils/pager";
import { apiListCustomer } from "@/api/customer-admin";
import { formatDate } from "@/utils/util";
import PasswordDialog from "./password.vue";

export default {
  components: {
    Pagination,
    PasswordDialog,
  },
  data() {
    return {
      params: {
        username: "",
        name: "",
        email: "",
        status: "",
      },
      pager: new Pager(),
    };
  },
  created() {
    this.getList();
  },
  methods: {
    formatDate,
    onReset() {
      this.$refs.searchRefs.resetFields();
      this.getList(1);
    },
    getList(page) {
      page && (this.pager.page = page);
      this.pager.request({
        callback: apiListCustomer,
        params: {
          ...this.params,
        },
      });
    },
    onNew() {
      this.$router.push("/perm/customer_detail");
    },
    onEdit(id) {
      this.$router.push({
        path: "/perm/customer_detail",
        query: { id },
      });
    },
    pagePermissionLabels(permissions) {
      const map = {
        clue: "询盘线索",
        access: "访问数据",
        rank: "排名数据",
        effect_report: "效果月报",
      };
      return (permissions || []).map((item) => map[item]).filter(Boolean);
    },
    onResetPassword(row) {
      this.$refs.passwordDialog.openDialog(row);
    },
  },
};
</script>

<style scoped>
.customer-site + .customer-site {
  margin-top: 8px;
}

.customer-site small {
  display: block;
  word-break: break-all;
}
</style>
